import axios from "axios";

var MedicationLabelResource = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function (params) {
        return axios.get(
            Apollo.resolveApiUrl('~/medicationlabel'),
            {
                params: params

            });
    },
};

export default MedicationLabelResource;


// WEBPACK FOOTER //
// ./src/models/MedicationLabelResource.js